import {
  computed,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { MenuItemService } from '@softline/application';
import { authorizationFn } from '@softline/auth';
import { SOFTLINE_PERMISSION_DASHBOARD } from './dashboard.shared';

// Cross-cutting boot providers (federation: ./ModuleGlobals; legacy composes
// them via dashboardProviders). Keep this graph free of page code.
export function provideDashboardGlobals(): Array<Provider | EnvironmentProviders> {
  return [
    provideEnvironmentInitializer(() => {
      const isAuthorized = authorizationFn();
      const menuItemService = inject(MenuItemService);
      menuItemService.add(
        computed(() => {
          if (!isAuthorized(SOFTLINE_PERMISSION_DASHBOARD)()) return [];
          return [
            {
              name: 'dashboardRoute',
              type: 'route' as const,
              outlet: 'nav-static',
              priority: 1,
              routerLink: ['/dashboard'],
              icon: 'fa-regular fa-tachograph-digital',
              title: '#DASHBOARD.APP',
            },
          ];
        })
      );
    }),
  ];
}
